import activityTypes from 'helpers/enums/activityTypes'

export default {
	[activityTypes.OPEN_ENDED_QUESTION]: 'openEndedQuestionPayload',
	[activityTypes.POLL_QUESTION]: 'pollQuestionPayload',
	[activityTypes.MULTIPLE_CHOICE_QUESTION]: 'multipleChoiceQuestionPayload',
	[activityTypes.MEDIA]: 'mediaPayload',
}
